import React, { useEffect, useState } from "react";
import CartTable2 from "../../../../components/AdminTable/CardTable2";
import axios from "axios";
import { apiKey } from "../../../../config/config";
import MessageCard from "../../../../components/AdminCards/MessageCard";
// import Dropdown from "../../../../components/AdminDropdown/Dropdown";
import { languageHelper } from "../../../../config/helperFunctions";



function CouponCodeReport() {
    const user = JSON.parse(localStorage.getItem("rms-admin"));
    const [columns] = useState([
        {
            header: languageHelper("SN") || "SN",
            cell: (row) => row.row.index + 1,
        },
        {
            header: languageHelper("Order #"),
            accessorKey: "sale_no",
        },
        {
            header: languageHelper("Customer Name"),
            accessorKey: "customer",
            cell: (row) => row.getValue()?.name,
        },
        {
            header: languageHelper("Coupon Code") || "Coupon Code",
            accessorKey: "coupon_code",
        },
        {
            header: languageHelper("Discount Amount") || "Discount Amount",
            accessorKey: "coupon_discount_amount",
        },
    ]);

    const [data, setData] = useState([]);
    const [error, setError] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();

    const [selectedOutlet, setSelectedOutlet] = useState();
    const handleOutletSelect = (e) => {
        setSelectedOutlet(e.value);
    };

    useEffect(() => {
        axios
            .get(`${apiKey}/api/rms/admin/coupon-report`, {
                headers: {
                    Authorization: `Bearer ${user?.token}`,
                },
                params: {
                    outletId: selectedOutlet || user?.user.outlet_id,
                    from: startDate,
                    to: endDate,
                },
            })
            .then((res) => {
                setData(res.data);
                setError(false);
            })
            .catch((err) => {
                setError(err.response.data.message || "Error occured");
            })
            .finally(() => { });
    }, [endDate, selectedOutlet, startDate, user?.token, user?.user.outlet_id]);

    if (error) {
        return <MessageCard error={error} />;
    }

    return (
        <main>
            <CartTable2
                data={data}
                columns={columns}
                heading={languageHelper("Coupon Code Report")}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                downloads={true}
                handleOutletSelect={handleOutletSelect}
            />
        </main>
    );
}

export default CouponCodeReport;
